
import { defineComponent, PropType } from "vue";
import { Insight } from "@/models/insight";
import { mapGetters, mapState } from 'vuex'
import { reportsGetters } from "@/store/reports/types";
import { Observation } from "@/store/reports/models";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "CalculatedPercent",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  computed: {
    ...mapState([
      'activeCaseId',
      'activeSlideId',
      'currentSlide',
    ]),
    ...mapGetters('reportsModule', {
      getObservation: reportsGetters.OBSERVATION
    }),
    denominator () {
      return this.getObservation(this.activeCaseId, this.activeSlideId, this.insight.controller.denominator_key);
    },
    numerator () {
      return this.getObservation(this.activeCaseId, this.activeSlideId, this.insight.controller.numerator_key);
    },
    percent () {
      // make sure we are not deviding by 0
      if (this.numerator.value >= 0 && this.numerator.value !== null && this.denominator.value) {
        return (this.numerator.value / this.denominator.value * 100).toFixed(1);
      } else {
        return null
      }
    },
    percentPresentation () {
      if (this.percent) {
        return `${this.percent}${this.insight.suffix}`
      } else {
        return null
      }
    }
  },
  props: {
    insight: {
      type: Object as PropType<Insight>,
    },
  },
  emits: {
    observationChange(observation: Observation): boolean {
      return (
        observation.key !== "" && observation.title !== "" && observation.value !== ""
      );
    },
  },
  methods: {
    handleChange () {
      const observation: Observation = {
        key: this.insight.key,
        title: this.t(`config.insight.slide.${this.currentSlide.tissueType}.${this.currentSlide.stain}.${this.insight.key}.title`),
        value: this.percent,
      }
      this.$emit('observationChange', observation)
    }
  },
  watch: {
    percent () {
      if (this.activeSlideId) {
        this.handleChange()
      }
    }
  }
})
